export const API_URL = `${process.env.GATSBY_API_URL}/api/v1`;
export const GATSBY_SIGNATURE = process.env.GATSBY_SIGNATURE ? process.env.GATSBY_SIGNATURE : '';
